import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { analysisKeys } from "./queries";

export const useInvalidateOnAuthChange = () => {
  const { isAuthenticated } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: analysisKeys.all });
  }, [isAuthenticated, queryClient]);
};
